import { buildQueryParamLink } from 'lib/helpers/urlHelper';
import { ISafeFetchConfigOptions } from 'lib/requests/fetch';
import { ILearningCenterClassroomAuthQueryParams } from './assignments/classroom/types';
import { learningCenterSafeFetch } from './fetch';
import { ILearningCenterKioskAuthQueryParams } from './kiosk/types';
import {
  ILearningCenterMetadata,
  LearningCenterUserSettingKey,
  LearningCenterUserSettingValue,
} from './types';

/**
 * GET requests
 */

export const getLearningCenterMetadata = (
  configOptions?: ISafeFetchConfigOptions
) => {
  return learningCenterSafeFetch<ILearningCenterMetadata>(
    '/learning-center/metadata',
    {},
    {
      ...configOptions,
      dontRedirect: true,
    }
  );
};

interface ILearningCenterPreviewMetadataQueryParams {
  key: string;
}

export const getLearningCenterPreviewMetadata = (
  queryParams: ILearningCenterPreviewMetadataQueryParams
) => {
  return learningCenterSafeFetch<ILearningCenterMetadata>(
    buildQueryParamLink('/learning-center/metadata/preview', queryParams)
  );
};

export const getLearningCenterKioskMetadata = (
  queryParams: ILearningCenterKioskAuthQueryParams
) => {
  return learningCenterSafeFetch<ILearningCenterMetadata>(
    buildQueryParamLink('/learning-center/metadata/kiosk', queryParams)
  );
};

export const getLearningCenterClassroomMetadata = (
  queryParams: ILearningCenterClassroomAuthQueryParams
) => {
  return learningCenterSafeFetch<ILearningCenterMetadata>(
    buildQueryParamLink('/learning-center/metadata/classroom', queryParams)
  );
};

interface ILearningCenterPolicyBotMetadataQueryParams {
  company: string;
}

export const getLearningCenterPolicyBotMetadata = (
  queryParams: ILearningCenterPolicyBotMetadataQueryParams
) => {
  return learningCenterSafeFetch<ILearningCenterMetadata>(
    buildQueryParamLink('/learning-center/metadata/policy-bot', queryParams)
  );
};

/**
 * POST/DELETE/PUT requests
 */

interface IUpdateUserSettingPayload {
  settingKey: LearningCenterUserSettingKey;
  value: LearningCenterUserSettingValue;
}

export const updateUserSetting = (payload: IUpdateUserSettingPayload) => {
  return learningCenterSafeFetch<void>('/learning-center/user-settings', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};
